import { useCallback } from 'react';

import type { BffApiUpdateItemError } from '../../../../types';
import type { CacheSyncInvoiceCacheKeys, InvoiceID } from '../../invoicesTypes';

import { useBffPostQuery } from '../../../common/reactQuery/hooks/useBffPostQuery';
import { InvoiceBffUrl } from '../../InvoiceBffUrl';

interface CacheSyncInvoiceOptions {
  cacheKeys?: CacheSyncInvoiceCacheKeys;
}

export interface CacheSyncInvoiceInput {
  invoiceId: InvoiceID;
  async?: boolean;
  withAncestorProjects?: boolean;
  withTask?: boolean;
  withSmartContracts?: boolean;
  withParentInvoice?: boolean;
  withChildInvoices?: boolean;
  withItems?: boolean;
}

export interface CacheSyncInvoiceInputData {
  async?: boolean;
  withAncestorProjects?: boolean;
  withTask?: boolean;
  withSmartContracts?: boolean;
  withParentInvoice?: boolean;
  withChildInvoices?: boolean;
  withItems?: boolean;
  actionOptions: {
    url: string;
  };
}

export type CacheSyncInvoiceError = BffApiUpdateItemError;
export type CacheSyncInvoiceResponseType = unknown;

function useCacheSyncInvoice({ cacheKeys }: CacheSyncInvoiceOptions = {}) {
  const {
    postQueryData,
    postQueryError,
    postQueryLoading,
    postQueryErrorMessage,
    postQuery,
    postQueryReset
  } = useBffPostQuery<
    CacheSyncInvoiceInputData,
    CacheSyncInvoiceResponseType,
    CacheSyncInvoiceError
  >({ cacheKeys });

  const handleCacheSyncInvoice = useCallback<
    (input: CacheSyncInvoiceInput) => Promise<unknown>
  >(
    (input) => {
      const { invoiceId, ...body } = input;
      return postQuery({
        ...body,
        actionOptions: {
          url: InvoiceBffUrl.cacheSync(invoiceId)
        }
      });
    },
    [postQuery]
  );

  return {
    cacheSyncInvoiceData: postQueryData,
    cacheSyncInvoiceError: postQueryError,
    cacheSyncInvoiceLoading: postQueryLoading,
    cacheSyncInvoiceErrorMessage: postQueryErrorMessage,
    cacheSyncInvoice: postQuery,
    handleCacheSyncInvoice,
    cacheSyncInvoiceReset: postQueryReset
  };
}

export default useCacheSyncInvoice;
